import axios from "axios";
import React, { useEffect } from "react";
import { Container, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import { SET_AUTHENTICATED } from "../../redux/types/user/UserActionTypes";
import AuthRoute from "../../utils/AuthRoute";
import Login from "../Body/Login/Login";
import Register from "../Body/Register/Register";
import AboutUs from "./AboutUs/AboutUs";
import Government from "./Government/Government";
import Home from "./Home/Home";
import PoliticalParty from "./PoliticalParty/PoliticalParty";
import Politician from "./Politician/Politician";
import RegisterConfirmation from "./Utils/RegisterConfirmation";
import RegistrationCompletion from "./Utils/RegistrationCompletion";
import ForgotPassword from "./Utils/ForgotPassword";
import ResetPassword from "./Utils/ResetPassword";
import jwtDecode from "jwt-decode";
import { getUserData, logoutUser } from "../../redux/actions/user/UserActions";
import {
  getCountries,
  getGovernments,
  getPoliticalParties,
  getPoliticians,
} from "../../redux/actions/data/DataActions";
import GovernmentView from "./View/GovernmentView";
import PoliticalPartyView from "./View/PoliticalPartyView";
import PoliticianView from "./View/PoliticianView";
import ValidRoute from "../../utils/ValidRoute";
import Search from "./Search/Search";
import Profile from "./Profile/Profile";
import ChangePassword from "./ChangePassword/ChangePassword";
import ContactUs from "./ContactUs/ContactUs";

function Body() {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = localStorage.userToken;

  useEffect(() => {
    if (token) {
      const decodedToken: any = jwtDecode(token);
      if (decodedToken.exp * 1000 < Date.now()) {
        dispatch(logoutUser(history));
        window.location.href = "/login";
      } else {
        dispatch({ type: SET_AUTHENTICATED });
        axios.defaults.headers.common["Authorization"] = token;
        dispatch(getUserData());
      }
    }
    dispatch(getCountries());
    dispatch(getPoliticalParties());
    dispatch(getPoliticians());
    dispatch(getGovernments());
  });
  return (
    <Container>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/government-listing" component={Government} />
        <Route path="/political-parties-listing" component={PoliticalParty} />
        <Route path="/politicians-listing" component={Politician} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/contact-us" component={ContactUs} />
        <Route exact path="/search-results/:keyword" component={Search} />

        <AuthRoute path="/user-login" component={Login} />
        <AuthRoute path="/user-register" component={Register} />

        <AuthRoute path="/user-forgot-password" component={ForgotPassword} />
        <AuthRoute
          path="/user-reset-password/:resetKey"
          component={ResetPassword}
        />
        <AuthRoute
          path="/user-register-confirmation/:confirmationKey"
          component={RegisterConfirmation}
        />
        <AuthRoute
          path="/user-register-completion"
          component={RegistrationCompletion}
        />
        <ValidRoute
          path="/government-view/:GovernmentID"
          component={GovernmentView}
        />
        <ValidRoute
          path="/political-party-view/:PoliticalPartyID"
          component={PoliticalPartyView}
        />
        <ValidRoute
          path="/politician-view/:PoliticianID"
          component={PoliticianView}
        />
        <ValidRoute path="/user-my-profile" component={Profile} />
        <ValidRoute path="/user-change-password" component={ChangePassword} />
      </Switch>
    </Container>
  );
}

export default Body;
